import { action } from 'sky-engine/api/index'

import { TOOL } from '@/api/apiModules'

/**
 * 上架
 * @returns
 */
export function onShelf(params) {
  return action(TOOL, 'onShelf', params)
}

/**
 * 下架
 * @returns
 */
export function offShelf(params) {
  return action(TOOL, 'offShelf', params)
}

/**
 * 获取工具下载链接
 * @returns
 */
export function getToolUrl(params) {
  return action(TOOL, 'getToolUrl', params)
}

/**
 * 获取工具
 * @returns
 */
export function getTool(params) {
  return action(TOOL, 'detail', params)
}

/**
 * 获取工具logo
 * @returns
 */
export function getToolLogo(params) {
  return action(TOOL, 'getToolLogo', params)
}
